import { AnimationStage } from '../animations/AnimationStage'
import { UnlockCurtain } from '../animations/UnlockCurtain'
import { useSession } from '../useSession'
import { Checking } from './Checking'
import { CodeGate } from './CodeGate'
import { InviteView } from './InviteView'

interface GuestSiteProps {
  /** A code off the URL, from a direct link on an invitation. */
  codeFromLink?: string | null
}

/** The site guests see: code prompt, then their invite and the wedding details. */
export function GuestSite({ codeFromLink = null }: GuestSiteProps = {}) {
  const session = useSession(codeFromLink)

  return (
    <>
      {/* Behind everything, and told which phase we are in so the background can
          react. See src/animations/README.md. */}
      <AnimationStage phase={session.phase} />

      {session.phase === 'checking' && <Checking />}

      {session.phase === 'locked' && (
        <CodeGate
          // A code that came in on a link and was turned down opens the prompt
          // already filled in, so the guest can see what was tried and fix it
          // rather than hunting for their invitation.
          initialCode={session.rejectedCode ?? ''}
          onSubmit={(code) => void session.signIn(code)}
          submitting={session.signingIn}
          error={session.signInError}
        />
      )}

      {/* The invite is already loaded here; the curtain decides when to reveal
          it, so the view never appears part-way through the animation. */}
      {session.phase === 'unlocking' && <UnlockCurtain onDone={session.completeUnlock} />}

      {session.phase === 'unlocked' && session.invite && (
        <InviteView
          invite={session.invite}
          onSaved={session.setInvite}
          onSignOut={() => void session.signOut()}
        />
      )}
    </>
  )
}
